import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const query = gql`
query IntentsResolver {
  maximumSkillValue
}`;

function getMaxSkillValue() {
  return apollo.client.query({
    query,
    fetchPolicy: 'network-only',
  }).then((res) => res.data.maximumSkillValue);
}

export default getMaxSkillValue;
